import { gql } from '@lcs/shared/api';

export const logOutAgent = gql`
   mutation LogOutAgent($queueMember: QueueMemberInput!) {
      queueMember: saveQueueMember(queueMember: $queueMember) {
         queueMemberId
         isLoggedIn
      }
   }
`;
